import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipProvider,
  TooltipContent,
  TooltipTrigger,
} from "~/atoms/tooltip";
import MaypoleIcon from "~/icons/MaypoleIcon";
import FrogIcon from "~/icons/FrogIcon";
import CrowIcon from "~/icons/CrowIcon";

// Midsommarafton is always the Friday between June 19 and June 25
export function getMidsommarafton(year: number): Date {
  const date = new Date(year, 5, 19);
  const daysUntilFriday = (5 - date.getDay() + 7) % 7;
  date.setDate(date.getDate() + daysUntilFriday);
  return date;
}

const now = new Date();
const midsommarafton = getMidsommarafton(now.getFullYear());
const diffMs = now.getTime() - midsommarafton.getTime();
const diffDays = diffMs / (1000 * 60 * 60 * 24);
// The week leading up to midsommarafton, through the end of midsommardagen
const isMidsommarSeason = diffDays >= -7 && diffDays < 2;

const DANCE_DURATION_S = 10;
const HOP_DURATION_S = 0.8;

const dancers = [FrogIcon, CrowIcon, FrogIcon, CrowIcon];

export function Midsommarstang() {
  const { t } = useTranslation();

  if (!isMidsommarSeason) {
    return null;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger className="cursor-help">
          <div className="relative h-14 w-20">
            <MaypoleIcon className="absolute bottom-0 left-1/2 z-10 h-14 -translate-x-1/2" />
            {dancers.map((DancerIcon, index) => (
              <div
                key={index}
                className="absolute inset-0 flex items-end justify-center"
              >
                <div
                  className="animate-midsommarDance relative origin-bottom"
                  style={{
                    animationDelay: `${(-index * DANCE_DURATION_S) / dancers.length}s`,
                  }}
                >
                  <div
                    className="animate-midsommarHop"
                    style={{
                      animationDelay: `${(-index * HOP_DURATION_S) / dancers.length}s`,
                    }}
                  >
                    <DancerIcon className="size-5" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{t(($) => $.commons.seasonal.midsommar)}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
